module.exports = __webpack_public_path__ + "img/weixin_kehu.caf5a961.png";